import { LimitTypeEnum } from 'src/model/limit'

/**
 * Select user limits from state
 * @param {Object} state - Redux state
 * @returns {Object} user limits entity
 */
export const selectUserLimits = state => state.userLimits?.entity

/**
 * Select user limits loading state
 * @param {Object} state - Redux state
 * @returns {boolean} loading state
 */
export const selectUserLimitsLoading = state => state.userLimits?.loading

/**
 * Select user limits error
 * @param {Object} state - Redux state
 * @returns {string|null} error message
 */
export const selectUserLimitsError = state => state.userLimits?.error

/**
 * Select current credits from state
 * @param {Object} state - Redux state
 * @returns {number} current available credits
 */
export const selectCurrentCredits = state =>
  state.userLimits?.currentCredits ?? 0

/**
 * Select refreshesAt date from user limits
 * @param {Object} state - Redux state
 * @returns {string|null} refreshesAt date
 */
export const selectRefreshesAt = state => {
  const userLimits = state.userLimits?.entity
  if (!userLimits) return null

  const aiLimitData = userLimits.find(
    x => x.limit.type === LimitTypeEnum.AICourseCreation,
  )

  return aiLimitData?.refreshedAt || null
}
